function sanitizeValue(value: unknown): unknown {
  if (typeof value === "string") {
    if (value.includes("@")) return "[redacted-email]";
    if (value.length > 160) return `${value.slice(0, 157)}...`;
    return value;
  }

  if (Array.isArray(value)) {
    return value.map(sanitizeValue);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(Object.entries(value as Record<string, unknown>).map(([key, entry]) => [key, sanitizeValue(entry)]));
  }

  return value;
}

export function isAuthProbeEnabled(): boolean {
  if (typeof window === "undefined") return false;

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("authProbe") === "1") return true;
    if (window.localStorage.getItem("iamv:authProbe") === "1") return true;
    if (window.sessionStorage.getItem("iamv:authProbe") === "1") return true;
  } catch {
    return false;
  }

  return false;
}

export function authProbe(stage: string, meta?: Record<string, unknown>) {
  if (!isAuthProbeEnabled() || typeof window === "undefined") return;

  const payload = sanitizeValue({
    ts: new Date().toISOString(),
    stage,
    ...meta,
  });

  const globalWindow = window as typeof window & { __IAMV_AUTH_PROBE_LOGS__?: unknown[] };
  globalWindow.__IAMV_AUTH_PROBE_LOGS__ = globalWindow.__IAMV_AUTH_PROBE_LOGS__ ?? [];
  globalWindow.__IAMV_AUTH_PROBE_LOGS__.push(payload);

  console.info("[AUTH_PROBE]", payload);
}
